import { render, staticRenderFns } from "./CompetitionRegistrationActionCrudField.vue?vue&type=template&id=811e2c2c&scoped=true"
import script from "./CompetitionRegistrationActionCrudField.vue?vue&type=script&lang=ts"
export * from "./CompetitionRegistrationActionCrudField.vue?vue&type=script&lang=ts"
import style0 from "./CompetitionRegistrationActionCrudField.vue?vue&type=style&index=0&id=811e2c2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811e2c2c",
  null
  
)

export default component.exports